import React from 'react';

const ProfessionalServices = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div className="page style-link style-ul font-16px">
        <div className="heading-2 top-heading-margin">Advisory and Working Groups</div>
        <div className="decoration-line"></div>
        <div className="style5">
          <div className="STYLE23">
            <ul>
              <li>Member, United Nations Advisory Body on AI.</li>
            </ul>
            <ul>
              <li>Co-Chair, Specialized Committee on AI, World Internet Conference (2024-).</li>
            </ul>
            <ul>
              <li>Expert, Ad Hoc Expert Group on AI Ethics, United Nations Education, Science and Culture Organization (UNESCO). (2020-).</li>
            </ul>
            <ul>
              <li>Expert, UNESCO High-level Expert Group on the Implementation of Recommendation on AI Ethics (2022-).</li>
            </ul>
            <ul>
              <li>Expert, World Health Organization (WHO) Expert Group on Ethics and Governance of Artificial Intelligence in Health (2019-).</li>
            </ul>
            <ul>
              <li>Member, National Governance Committee of Next Generation Artificial Intelligence, Ministry of Science and Technology China (2019-).</li>
            </ul>
            <ul>
              <li>Board Member, Committee on Artificial Intelligence, National Committee on Science and Technology Ethics, China (2020-).</li>
            </ul>
            <ul>
              <li>Chair, Professional Ethics Committee of Information Technology and Artificial Intelligence, the Science and Ethics Committee, Chinese Academy of Sciences (2021-).</li>
            </ul>
            <ul>
              <li>Chair, Committee on Mind Computation, Chinese Association for Artificial Intelligence (2022-).</li>
            </ul>
            <ul>
              <li>Deputy Chair, Working Group on Artificial Intelligence, World Internet Conference (2023-).</li>
            </ul>
            <ul>
              <li>Founding Executive Chair, AI for Sustainable Development Goals Cooperation Network (2020-).</li>
            </ul>
            <ul>
              <li>Chair, Professional Committee on Information Technology and Artificial Intelligence, Science and Technology Ethics Committee, Chinese Academy of Sciences (2021-).</li>
            </ul>
            <ul>
              <li>Member, Advisory Council, Institute of Ethics in AI, University of Oxford (2021-).</li>
            </ul>
            <ul>
              <li>Board of Advisors. Carnegie Council for Ethics in International Affairs (2021-).</li>
            </ul>
            <ul>
              <li>Consultation Expert, National Commission of the People's Republic of China for UNESCO (2020-).</li>
            </ul>
            <ul>
              <li>Deputy Chair, Committee on AI Governance and Trustworthiness, Artificial Intelligence Industry Alliance, China (2021-).</li>
            </ul>
            <ul>
              <li>Invited Expert, Research Center for Next Generation Artificial Intelligence Development, Ministry of Science and Technology China. (2018-).</li>
            </ul>
            <ul>
              <li>International Advisory Board Member. Paradigms of Artificial General Intelligence and Their Associated Risks. University of Cambridge. (2018-2021).</li>
            </ul>
            <ul>
              <li>Committee Member, Global Future Council on China. World Economic Forum. (2019-2020).</li>
            </ul>
            <ul>
              <li>Committee Member, Global Future Council on Values, Ethics and Innovation. World Economic Forum. (2018-2019).</li>
            </ul>
          </div>
        </div>
        <div className="heading-2 pt-12">Editorial Services</div>
        <div className="decoration-line"></div>
        <div className="style5">
          <div className="style4">
            <ul>
              <li className="STYLE23">[Co-Editor-in-Chief] <a href="https://www.baai.ac.cn/research/translation-series-on-ai-ethics-en" target="_blank">Translation Series on AI Ethics, Governance and Sustainable Development</a> (2020)</li>
            </ul>
            <ul>
              <li className="STYLE23">[Editorial Board Member] <a href="https://www.springer.com/journal/43681/" target="_blank">AI &amp; Ethics</a>, Springer (2020-).</li>
            </ul>
            <ul>
              <li className="STYLE23">[Editorial Board Member] <a href="https://www.worldscientific.com/worldscinet/jaic" target="_blank">Journal of Artificial Intelligence and Consciousness</a>, World Scientific (2019-).</li>
            </ul>
            <ul>
              <li className="STYLE23"><span className="STYLE23">[Associate Editor] <a href="http://www.journals.elsevier.com/cognitive-systems-research" target="_blank">Cognitive Systems Research</a>, Elsevier (2016-2020). </span></li>
            </ul>
          </div>
        </div>
        <div className="style5">
          <div className="style4">&nbsp;</div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalServices;